<h1 class="partner-heading">Partner Offers</h1>
<ng-container *ngIf="loading" class="row">
    <div class="col-lg-12 col-md-12">
        <div class="loading-div-tiny" id="fp-loading" aria-live="polite" aria-busy="true" role="alert" tabindex="2">
            <div class="loading-spinner">
                <div class="large progress" alt="Loading..." aria-label="Loading...">
                    <span class="visually-hidden">Loading...</span>
                    <div class="prog1">
                        <div class="prog2"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!loading">
    <ng-container *ngIf="isError">
        <div class="no-partner-container" role="alert" aria-live="assertive">
            <div class="no-partner-logo-container">
                <img aria-hidden="true" class="partner-logo"
                     src="/ocrp-rewards-ui/dist/assets/images/icon/page-load-error.svg" alt="Error loading page" />
            </div>
            <div class="no-partner-body">
                <h2 class="no-partner-heading-size">Oh crumbs</h2>
                <p class="no-partner-description-text"> {{errorMessage}} </p>
            </div>
            <div class="no-partner-footer">
                <button type="button" class="btn btn-xl btn-primary body-text no-partner-footer__button" role="link"
                        (click)="openDealsPage()" (keypress)="openDealsPage()" aria-label="View deals">
                    View deals
                </button>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!isError">
        <ng-container *ngIf="partnerOfferDeals && partnerOfferDeals.length === 0">
            <div class="no-partner-container" role="alert" aria-live="polite">
                <div class="no-partner-logo-container">
                    <img aria-hidden="true" class="partner-logo"
                         src="/ocrp-rewards-ui/dist/assets/images/icon/empty-partners.svg" alt="" />
                </div>
                <div class="no-partner-body">
                    <h2 class="no-partner-heading-size">No partner offers at this time</h2>
                    <p class="no-partner-description-text">We still have a ton of other deals you could check out.</p>
                </div>
                <div class="no-partner-footer">
                    <button type="button" class="btn btn-xl btn-primary body-text no-partner-footer__button" role="link"
                            (click)="openDealsPage()" (keypress)="openDealsPage()" aria-label="View deals">
                        View deals
                    </button>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="partnerOfferDeals.length > 0 && !isPartnerPromotionV2">
            <ng-container>
                <app-partner-promotion [partnerOfferDeals]="partnerOfferDeals" [appHostURL]="appHostURL"
                                       [currentEnvironment]="currentEnvironment" [userInfo]="userInfo" [banner]="banner">
                </app-partner-promotion>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="partnerOfferDeals.length > 0 && isPartnerPromotionV2">
            <ng-container>
                <app-partner-promotion-V2 [partnerOfferDeals]="partnerOfferDeals" [appHostURL]="appHostURL" [isLoggedInTokenValid]="isLoggedInTokenValid"
                                          [currentEnvironment]="currentEnvironment" [userInfo]="userInfo" [banner]="banner">
                </app-partner-promotion-V2>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-container>
